import Before from '@elem/SVGIcon/DeltaProUltra/Before';
import BeforeH5 from '@elem/SVGIcon/DeltaProUltra/BeforeH5';
import After from '@elem/SVGIcon/DeltaProUltra/After';
import AfterH5 from '@elem/SVGIcon/DeltaProUltra/AfterH5';
import Close from '@elem/SVGIcon/DeltaProUltra/Close';
import { getSubscribeNumber, submitJoin, submitScribe } from '@elem/Service/delta-pro-ultra';
import { message } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getPagesPrivacyPolicy } from '@/utils/common';

export default function B() {
    const { useLang, useRouter, useEffect, useState, Link, gtm } = useGlobal();
    const { t } = useLang('delta_pro_ultra.teaser');
    const { locale } = useRouter();
    const [num, setNum] = useState(0);
    const [input, setInput] = useState('');
    const [inputVal, setInputVal] = useState('');
    const [check, setCheck] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showMsg, setShowMsg] = useState('');

    const handleInputChange = (v: any) => {
        setInput(v.target.value);
        setInputVal(v.target.value);
    };

    const handleCheck = () => {
        setCheck(!check);
        if (!check && showMsg) {
            setShowMsg('');
        }
        if (check && !showMsg) {
            setShowMsg(t('secB_msg_uncheck'));
        }
    };

    const handleSubmit = async () => {
        const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        if (!input) {
            return setShowMsg(t('secB_msg_null'));
        }
        if (!emailRegex.test(input)) {
            return setShowMsg(t('secB_msg_wrong'));
        }
        if (!check) {
            return setShowMsg(t('secB_msg_uncheck'));
        }
        try {
            const data =
                locale === 'jp'
                    ? {
                          email: input.trim(),
                          contactListId: '743933504',
                          fields: [
                              {
                                  id: '4431',
                                  type: 'single',
                                  value: 1,
                                  overwrite: true,
                              },
                              {
                                  id: '31',
                                  type: 'single',
                                  value: 1,
                                  overwrite: true,
                              },
                              {
                                  id: '9157',
                                  type: 'multiple',
                                  value: [1],
                                  overwrite: false,
                              },
                          ],
                      }
                    : { email: input.trim() };
            const res = await submitScribe(locale, data, {
                sector_name: `DPU_${t('secB_title')}`,
                entry_position: '2',
            });
            if (res?.code === '0') {
                if (['us', 'ca'].includes(locale)) {
                    setShowModal(true);
                }
                if (['jp'].includes(locale)) {
                    message.success(t('secB_modal_title'));
                }
                setInput('');
                setShowMsg('');
                if (locale !== 'jp') {
                    try {
                        const res = await getSubscribeNumber(locale);
                        if (res?.code === '0') {
                            setNum(res?.data);
                        } else {
                            console.error(res?.message);
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }
                try {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'activity_submit',
                        button_name: t('secB_btn'),
                        status: 'success',
                        tag: 'Agree',
                    });
                } catch (e) {
                    console.error(e);
                }
            } else {
                setShowMsg(res?.message);
                console.error(res?.message);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('secB_btn'),
                    status: 'fail',
                    tag: 'Agree',
                });
            }
        } catch (e) {
            console.error(e);
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('secB_btn'),
                status: 'fail',
                tag: 'Agree',
            });
        } finally {
            // setShowModal(true);
        }
    };

    const handleJoin = async () => {
        try {
            const res = await submitJoin(locale, { email: inputVal.trim() });
            if (res?.code !== '0') {
                console.log(res?.message);
            }
        } catch (e) {
            console.error(e);
        }
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join',
                button_name: t('secB_modal_btn'),
            });
        } catch (e) {
            console.error(e);
        }
        return true;
    };

    useEffect(() => {
        (async () => {
            try {
                const res = await getSubscribeNumber(locale);
                if (res?.code === '0') {
                    setNum(res?.data);
                } else {
                    console.error(res?.message);
                }
            } catch (e) {
                console.error(e);
            }
        })();
    }, []);

    return (
        <div className={`delta-pro-ultra-B ${css['delta-pro-ultra-B']}`}>
            <div className={`block ${showModal ? 'hide' : ''}`}></div>
            <div className={`block-content ${showModal ? 'hide' : ''}`}>
                <div className="default-content">
                    <Before className="icon icon-before" />
                    <BeforeH5 className="icon icon-h5 icon-before" />
                    <p className="title">{t('secB_title')}</p>
                    {['us', 'ca'].includes(locale) && (
                        <p className="text">
                            {t.rich('secB_text', {
                                num,
                            })}
                        </p>
                    )}
                    <div className="control">
                        <input type="text" className="input" value={input} onChange={handleInputChange} placeholder={t('secB_placeholder')} />
                        <button className="subscribe" onClick={handleSubmit}>
                            {t('secB_btn')}
                        </button>
                    </div>
                    {showMsg && <p className="error-msg">{showMsg}</p>}
                    <div className="agreement">
                        <input type="checkbox" className="agree-check" id="agree" checked={check} onChange={handleCheck} />
                        <label htmlFor="agree" className="agree-label">
                            {t.rich('secB_agree', {
                                a1: (text: string) => (
                                    <Link className="link" href={`https://${locale}.ecoflow.com/pages/terms-of-use`}>
                                        {text}
                                    </Link>
                                ),
                                a2: (text: string) => (
                                    <Link className="link" href={getPagesPrivacyPolicy(locale)}>
                                        {text}
                                    </Link>
                                ),
                            })}
                        </label>
                    </div>
                    <After className="icon icon-after" />
                    <AfterH5 className="icon icon-h5 icon-after" />
                </div>
                {/* {showModal && ( */}
                <div className="modal">
                    <div className="modal-content">
                        <Close className="close" onClick={() => setShowModal(false)} />
                        <p className="modal-title">{t('secB_modal_title')}</p>
                        <p className="modal-text">{t('secB_modal_text')}</p>
                        <a href={'https://bit.ly/3PofSeh'} className="modal-btn" target="_blank" onClick={handleJoin} rel="noreferrer">
                            {t('secB_modal_btn')}
                        </a>
                    </div>
                </div>
                {/* )} */}
            </div>
        </div>
    );
}
